import React from 'react';
import { ErrorBoundaryFallback } from '@/components';
import { usePopStateDetector } from '@/hooks/usePopStateDetector';
import { useCachedCategoryInfo } from '@/module/public/hooks/useFetchCategoryInfo';
import { useGetAllQuizes } from '@/module/public/hooks/useGetAllQuizes';
import { useScrollRestoration } from '@/module/public/hooks/useScrollRestoration';
import { useCreateSubjectNameGetter } from '@/shared/category/useCreateSubjectNameGetter';
import { filterExternalPlatformQuizzes, useExternalPlatform } from '@/shared/externalPlatform';
import { EmptyQuizList } from '@/shared/quizList/EmptyQuizList';
import { useGetQuizListItemButtons } from '@/shared/quizList/hooks';
import { InfiniteListView } from '@/shared/quizList/InfiniteListView';
import { QuizListItem } from '@/shared/quizList/QuizListItem';
import { useSearchQuizQuery } from '../hooks/useSearchQuizQuery';
import { CreateQuizBannerItem } from './CreateQuizBannerItem';
export const QuizList = () => {
  const {
    flatData,
    isLoading,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage
  } = useGetAllQuizes();
  const {
    searchText
  } = useSearchQuizQuery();
  const isSearchMode = Boolean(searchText);
  const isPopState = usePopStateDetector();
  useScrollRestoration(!isLoading, isPopState);
  const getQuizButtons = useGetQuizListItemButtons('public');
  const {
    categoryTreeData
  } = useCachedCategoryInfo();
  const {
    mode
  } = useExternalPlatform();
  const subjectNameGetter = useCreateSubjectNameGetter(categoryTreeData?.subjectTree);
  const visibleQuizzes = filterExternalPlatformQuizzes(flatData, mode);
  return <InfiniteListView items={visibleQuizzes} isLoading={isLoading} isError={isError} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} isFetchingNextPage={isFetchingNextPage} HeaderComponent={isSearchMode ? null : <CreateQuizBannerItem />} renderItem={quiz => <QuizListItem eventLocation={'public'} isHideAuthor={false} alwaysDropDownMenu={false} subjectName={subjectNameGetter({
    subjectGroupId: quiz.categoryInfo?.subject,
    subSubjectGroupId: quiz.categoryInfo?.subSubject
  })} menuItems={getQuizButtons(quiz)} quizSet={quiz} key={quiz.id} />} EmptyComponent={<EmptyQuizList type={'public'} />} ErrorComponent={<ErrorBoundaryFallback />} LoadingComponent={null} data-sentry-element="InfiniteListView" data-sentry-component="QuizList" data-sentry-source-file="QuizList.tsx" />;
};